import React, { useState, useEffect } from "react";
import moment from "moment";
import TimePicker from "antd/lib/time-picker";

function TimeSheduleClassCard({ data, index, pos, setTimmerHide, setCountValue, setPeriodValue }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount((data.periods || []).length);
  }, [data]);

  useEffect(() => {
    if (count >= 1) {
      if (data.periods.length > count) {
        setPeriodValue(null, null, data.periods.slice(0, count));
      } else if (data.periods.length < count) {
        setPeriodValue(null, null, [
          ...data.periods,
          ...Array(count - data.periods.length).fill({ startTime: "", endTime: "" }),
        ]);
      }
    }
  }, [count, data, setPeriodValue]);

  const intervalHideHandler = (pos, i) => {
    setTimmerHide(true);

    setTimeout(() => {
      const intervalElem = document.getElementById(`Inter-${pos}-${i + 1}`);
      if (intervalElem) intervalElem.innerHTML = "";
      setTimmerHide(false);
    }, 6000);
  };

  return (
    <div
      className="flex flex-col justify-center m-7 px-0 bg-slate-100 dark:bg-neutral-600 text-[#002267] rounded-[20px] w-[450px]"
      key={`${data._id}In`}
    >
      <div
        className="flex justify-around text-slate-900 dark:text-slate-100 text-[26px] font-semibold mt-5 mb-4 py-2 bg-slate-500 dark:bg-neutral-900 uppercase"
        key={`${data._id}Title`}
      >
        <span>{data.className?.substring(0, 3)}</span>
        <input
          type="number"
          placeholder="Count"
          min={1}
          value={count}
          onChange={(e) => {
            const { value } = e.target;
            if ((value >= 1 && value <= 10) || value === "") {
              setCount(value);
              setCountValue(value);
            }
          }}
          className="text-[#FF7E3D] dark:text-[#e86f54] dark:bg-slate-300 h-[50px] w-[50px] text-center border-none rounded-full flex justify-center items-center shadow-[0_0_4px_rgba(0,0,0,0.62)] appearance-none placeholder:text-[16px] 
          [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
        />
      </div>
      {data.periods?.map((period, i) => (
        <div className="flex flex-col my-2 px-5" key={`${data._id}${i}`}>
          <span className="m-2 text-lg  font-bold uppercase dark:text-slate-100">{`Period - ${i + 1}`}</span>
          <div className="flex justify-around  ">
            <TimePicker
              format="hh:mm A"
              minuteStep={5}
              value={moment(period.startTime, "hh:mm A").isValid() ? moment(period.startTime, "hh:mm A") : undefined}
              className="rounded-[30px] shadow-[0_0_14px_-1px_#a2a1a1] dark:bg-slate-300"
              onChange={(value) => {
                const endTime = data.periods[i - 1]?.endTime;

                if (endTime) {
                const selectedTime = value?.format("hh:mm A");
if (!selectedTime) return; // <-- add this guard to avoid error
const parsed = selectedTime.split(":");


                  const selD = parsed[1].split(" ")[1];
                  const selHR =
                    parseInt(parsed[0]) === 12 && selD === "AM"
                      ? 0
                      : parseInt(parsed[0]) === 12 && selD === "PM"
                      ? 12
                      : selD === "AM"
                      ? parseInt(parsed[0])
                      : parseInt(parsed[0]) + 12;
                  const selMIN = parseInt(parsed[1].split(" ")[0]);
                  const parsedEdate = endTime.split(":");

                  const endD = parsedEdate[1].split(" ")[1];
                  const endHR =
                    parseInt(parsedEdate[0]) === 12 && endD === "AM"
                      ? 0
                      : parseInt(parsedEdate[0]) === 12 && endD === "PM"
                      ? 12
                      : endD === "AM"
                      ? parseInt(parsedEdate[0])
                      : parseInt(parsedEdate[0]) + 12;
                  const endMIN = parseInt(parsedEdate[1].split(" ")[0]);

                  const hrDif = selHR - endHR;
                  if (hrDif > 0) {
                    const timeMin = selHR * 60 + selMIN - (endHR * 60 + endMIN);
                    const interHr = Math.floor(timeMin / 60);
                    const interMIN = timeMin % 60;
                    document.getElementById(`Inter-${pos}-${i + 1}`).innerHTML = `Interval ${interHr} -hr ${interMIN} -m found `;
                  } else if (hrDif < 0) {
                    document.getElementById(`Inter-${pos}-${i + 1}`).innerHTML = `Please check the time ...`;
                  } else if (hrDif === 0) {
                    const interMIN = selMIN - endMIN;
                    if (interMIN > 0)
                      document.getElementById(`Inter-${pos}-${i + 1}`).innerHTML = `Interval ${interMIN} -m found`;
                    else if (interMIN < 0)
                      document.getElementById(`Inter-${pos}-${i + 1}`).innerHTML = `Please check the time .... `;
                  }
                  intervalHideHandler(pos, i);
                }

                setPeriodValue(i, "startTime", value?.format("hh:mm A"));
              }}
            />
            <TimePicker
              format="hh:mm A"
              minuteStep={5}
              value={moment(period.endTime, "hh:mm A").isValid() ? moment(period.endTime, "hh:mm A") : undefined}
              className="rounded-[30px] shadow-[0_0_14px_-1px_#a2a1a1] dark:bg-slate-300"
              onChange={(value) => {
                setPeriodValue(i, "endTime", value?.format("hh:mm A"));
              }}
            />
          </div>
          <span
            id={`Inter-${pos}-${i + 1}`}
            className="text-center text-[#148E87] mt-3 font-extrabold"
          ></span>
        </div>
      ))}
    </div>
  );
}

export default TimeSheduleClassCard;
